import React from 'react'
import { ShieldCheckIcon, TrashIcon } from '@heroicons/react/24/outline'

import { ProfileView, ProfileViewWithShadowBan } from '../../../../api/client'
import ConfirmModal from '../../../ConfirmModal'
import { getProfileDisplayName, ProfileContentData } from './ProfileNameDisplay'

export type ShadowBanAction = 'enable' | 'disable'

type Props = {
    open: boolean
    profile: ProfileView | ProfileViewWithShadowBan | null
    loading: boolean
    action: ShadowBanAction
    onConfirm: () => void
    onCancel: () => void
    contentData?: ProfileContentData
}

export default function ShadowBanConfirmationModal(props: Props) {
    const { open, profile, loading, action, onConfirm, onCancel, contentData } = props
    const isEnable = action === 'enable'
    const title = isEnable ? 'Enable ban' : 'Disable ban'
    const confirmLabel = isEnable ? 'Enable ban' : 'Disable ban'
    const displayName = getProfileDisplayName(profile, contentData)
    const description = displayName
        ? isEnable
            ? `Are you sure you want to enable a shadow ban for "${displayName}"?`
            : `Are you sure you want to disable the shadow ban for "${displayName}"?`
        : isEnable
          ? 'Are you sure you want to enable this shadow ban?'
          : 'Are you sure you want to disable this shadow ban?'

    return (
        <ConfirmModal
            open={open}
            onClose={onCancel}
            onConfirm={onConfirm}
            title={title}
            description={description}
            confirmLabel={confirmLabel}
            loading={loading}
            icon={
                isEnable ? (
                    <ShieldCheckIcon className="h-6 w-6" aria-hidden="true" />
                ) : (
                    <TrashIcon className="h-6 w-6" aria-hidden="true" />
                )
            }
            iconClassName={isEnable ? 'bg-arwen-100 text-arwen-700' : 'bg-red-100 text-red-600'}
        />
    )
}
